import React, {
  useEffect,
  useState
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Parser from "html-react-parser";
import * as CMSActions from "./store/actions";
import useMediaQuery from "app/hooks/useMediaQuery";
import { Carousel } from "react-bootstrap";
import "./BannerHero.css";

const ROOT = process.env.REACT_APP_CMS_STATIC;

const BannerHero = () => {
  const dispatch = useDispatch();

  const is4K = useMediaQuery("(min-width: 3840px)");
  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  const [banners, setBanners] = useState([]);

  const { token } = useSelector(({ Base }) => Base.Token);
  const { contentBanner } = useSelector(({ banner }) => banner.banner);

  const contenedorL4L5YConsultar = () => {
    let cls = "";
    if (isIphoneLandscape) {
      cls = "d-flex flex-column";
    } else if (isIpadPortrait || isDesktop || is4K) {
      cls = "d-flex";
    }
    return cls;
  };

  useEffect(() => {
    token && !contentBanner && dispatch(CMSActions.getBanner(token));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (contentBanner && contentBanner.length > 0) {
      setBanners(contentBanner.sort((a, b) => a.orden - b.orden));
    }
  }, [contentBanner]);

  return (
    <>
      <div>
        {banners.length > 0 ? (
          <Carousel 
            prevIcon={<i className="bi bi-chevron-left banner-carousel-buttons"></i>}
            nextIcon={<i className="bi bi-chevron-right banner-carousel-buttons"></i>}
          >
            {banners.map((banner, index) => {
              const {
                imagenFondoIphone,
                imagenFondoIpad,
                imagenFondo,
                linea1,
                linea2,
                linea3,
                linea4,
                linea5,
                botonConsultar,
                enlaceConsultar,
                heroImage
              } = banner

              const image = isIphoneLandscape ? (`${ROOT}${imagenFondoIphone.urls[0]}`) : isIpadPortrait ? (`${ROOT}${imagenFondoIpad.urls[0]}`) : (`${ROOT}${imagenFondo.urls[0]}`)

              return (
                <Carousel.Item key={`banner-carousel-item${index}`}>
                  <div
                    className="background-container main-banner-container"
                    style={{ backgroundImage: `url(${image})` }}
                  >
                    <div className="containerTexto">
                      {linea1 && (
                        <div className="linea1">
                          {Parser(linea1.html)}
                        </div>
                      )}
                      {linea2 && (
                        <div className="linea2">
                          {Parser(linea2.html)}
                        </div>
                      )}
                      {linea3 && (
                        <div className="linea3">
                          {Parser(linea3.html)}
                        </div>
                      )}
                      <div className={contenedorL4L5YConsultar()}>
                        {(linea4 || linea5) && (
                          <div
                            className="d-flex flex-column justify-content-center"
                            style={{ marginRight: "32px" }}
                          >
                            {linea4 && (
                              <div className="linea4" style={{ whiteSpace: "nowrap" }}>
                                {Parser(linea4.html)}
                              </div>
                            )}
                            {linea5 && (
                              <div className="linea5" style={{ whiteSpace: "nowrap" }}>
                                {Parser(linea5.html)}
                              </div>
                            )}
                          </div>
                        )}
                        {botonConsultar && enlaceConsultar && (
                          <div className="my-auto" style={{ height: "50px" }}>
                            <a
                              href={enlaceConsultar.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                className="h-100"
                                src={ROOT + botonConsultar.urls[0]}
                                alt={enlaceConsultar.text}
                              />
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="containerMainImage">
                      {heroImage && heroImage?.urls.length > 0 && (
                        <img
                          alt="heroImage"
                          src={ROOT + heroImage.urls[0]}
                          className="hero-image"
                        />
                      )}
                    </div>
                  </div>
                </Carousel.Item>
              )
            })}
          </Carousel>
        ) : (<></>)}
      </div>
    </>
  );
};

export default BannerHero;
